<span>
  <ng-container *ngFor="let appointmentCommittee of value; let isLast = last;">
    {{ appointmentCommittee.committee.displayName.fr }}
    <br *ngIf="!isLast">
  </ng-container>
</span>